import { ApiType } from "@gymflow/common";
import { ApiListResponse, ProductDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { productQueryKeys } from "./productQueryKeys";
import { useProductCategorySearchList } from "./useProductCategorySearch";

export async function productListQueryFn({
  api,
  filter,
}: {
  api: ApiType;
  filter: Parameters<ApiType["productApi"]["find"]>[0];
}) {
  return (await api.productApi.find({ ...filter })).data;
}

export function useProductList(
  {
    api,
    opts,
  }: {
    api: ApiType;
    opts: Parameters<ApiType["productApi"]["find"]>[0];
  },
  queryOpts?: Omit<
    UseQueryOptions<
      ApiListResponse<ProductDTO>,
      unknown,
      ApiListResponse<ProductWithCategoryName>
    >,
    "queryKey"
  >,
) {
  const categories = useProductCategorySearchList({
    api,
    opts: { limit: 1000, page: 0 },
  });

  return useQuery({
    queryKey: productQueryKeys.list(opts),
    queryFn: () => productListQueryFn({ api, filter: opts }),
    enabled: categories.isSuccess,
    select: (products) => ({
      ...products,
      content: products.content.map((product) => ({
        ...product,
        categoryName: categories.data!.content.find(
          (category) => category.id === product.productCategoryId,
        )?.name as string,
      })),
    }),
    ...queryOpts,
  });
}

export interface ProductWithCategoryName extends ProductDTO {
  categoryName: string;
}
